import React from 'react';
import { ReceiptText, CircleCheck, CircleX } from 'lucide-react';
import { StatCard } from '../../common';
import { formatNumber } from '../../../utils/format';
import { usePriceAnalytics } from './priceElements.controller';

export default function PriceAnalytics({ prices }) {
    const analytics = usePriceAnalytics(prices);

    return (
        <div className="grid gap-4 grid-cols-1 sm:grid-cols-3">
            <StatCard
                label="Total Listas"
                value={formatNumber(analytics.totalLists)}
                icon={<ReceiptText />}
                tone="brand"
                hint={`${analytics.moderno} moderno · ${analytics.tradicional} tradicional`}
            />
            <StatCard
                label="Listas Activas"
                value={formatNumber(analytics.activeLists)}
                icon={<CircleCheck />}
                tone="success"
                hint="En uso actualmente"
            />
            <StatCard
                label="Listas Inactivas"
                value={formatNumber(analytics.inactiveLists)}
                icon={<CircleX />}
                tone="danger"
                hint="No disponibles"
            />
        </div>
    );
}
